// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3yNMi","notes":"Notes_notes__2264C"};